import { render, staticRenderFns } from "./programDegree.vue?vue&type=template&id=69e84571"
import script from "./programDegree.vue?vue&type=script&lang=js"
export * from "./programDegree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports